import debugout from '@/assets/js/debugout';
const bugout = new debugout() as any;
bugout.realTimeLoggingOn = false;
bugout.useTimestamps = true;
bugout.useLocalStorage = true;
class Log {
  private isStart = false;

  public log(obj) {
    console.log(obj);
    bugout.log(obj);
    const text = bugout.getLog();
    console.log('text', text);
    bugout.clear();
  }
  public log1(obj) {
    console.log(obj);
    bugout.log(obj);
  }
  public getLog() {
    bugout.getLog();
  }
}
export default new Log();



// WEBPACK FOOTER //
// ./src/utils/log.ts